export default {
  date_sameDay: '[Сегодня в] HH:mm',
  date_lastDay: '[Вчера в] HH:mm',
  date_lastWeek: 'dddd HH:mm',
  date_sameElse: 'DD MMMM YYYY [в] HH:mm',
  operation_type_outgoing_payment: 'Исходящий платеж',
  operation_type_withdrawal: 'Вывод',
  operation_type_deposit: 'Deposit',
  // auh_view
  accountRestrictedGoToKyc: 'Возможности вашего аккаунта ограничены. Для расширения функциональности пройдите',
  auth_copyright: '© DIT',
  disposable_mail_error: 'Адрес почты с неразрешенного домена',
  invalid_email_error: 'Неправильный адрес электронной почты',
  expired_signature: 'Ошибка просроченной подписи. Проверьте правильность времени на своем устройстве и попробуйте снова',
  not_found: 'Неправильный email или пароль',
  email_not_verified_on_recovery: 'Невозможно восстановить учетную запись с непроверенной электронной почтой',
  email_verified: 'Электронная почта успешно подтверждена',
  email_not_verified: 'Электронная почта не подтверждена. Пожалуйста, проверьте свою почту',
  email_sent: 'Запрос успешно отправлен. Пожалуйста, проверьте Вашу электронную почту',
  password_not_verified: 'Неправильный пароль',
  password_do_not_match: 'Пароли не совпадают',
  password_change_failed: 'Не удалось изменить пароль. Попробуйте позже',
  password_changed: 'Пароль успешно изменен',
  recovery_wallet_not_found: 'Неправильная почта или ключ восстановления',
  role_mail_error: 'Ролевые адреса почты запрещены',
  recovered: 'Аккаунт успешно восстановлен. Теперь Вы можете войти с новыми учетными данными',
  tfa_wrong_code: 'Неправильный код',
  tfa_recovery: 'Утеряна двухфакторная аутентификация. Двухфакторную аутентификацию можно восстановить в настройках',
  tfa_to_many_attempts: 'Двухфакторная аутентификация потеряна. Аккаунт заблокирован',
  tfa_recovery_blocked: 'Двухфакторная аутентификация потеряна. Аккаунт заблокирован',
  tfa_recovery_unblocked: 'Двухфакторная аутентификация успешно сброшена',
  user_exists: 'Пользователь с такой почтой уже существует',
  wrong_password: 'Неправильный пароль',
  tfa_disabled: 'Двухфакторная аутентификация успешно отключена',
  auth_and: 'и',
  recovery_title: 'Восстановление аккаунта',
  recovery_description: 'Знаете реквизиты для входа?',
  // common
  cm_complete_validation: 'Заполните все обязательные поля перед тем, как продолжить',
  cm_balance_created: '%{code} успешно добавлен на ваш счет',
  cm_error_occured: 'Произошла ошибка. Пожалуйста, попробуйте позже',
  // contracts_view
  cont_signed: 'Подписано',
  cont_counterparty_name: 'Имя, электронная почта или ID аккаунта контрагента',
  cont_counterparty_email_or_id: 'Почта или ID аккаунта контрагента',
  cont_contract_number: 'Номер контракта',
  cont_show_active_disputes: 'Показать только активные контракты',
  cont_counterparty: 'Контрагент',
  cont_no_signed_contracts: 'Нет подписанных контрактов',
  cont_no_signed_contracts_desc: 'Здесь будет отображаться список подписанных вами контрактов',
  cont_active_disputes: 'Активыные обсуждения',
  cont_details: 'Детали контракта',
  cont_company_id: 'ID аккаунт компании',
  cont_new_contract: 'Новый контракт',
  cont_sign_and_send: 'Подписать и отправить',
  cont_sign_and_send_to_counterparty: 'Подписать и отправить контрагенту',
  cont_signature_requests: 'Запросы подписи',
  cont_no_archived_contracts: 'Нет архивированных контрактов',
  cont_no_archived_contracts_desc: 'Здесь будет отображаться список архивированных контрактов',
  cont_no_contract_requests: 'Нет контрактных запросов',
  cont_no_contract_requests_desc: 'Здесь будет отображаться список контрактных запросов',
  cont_no_invoice_requests: 'Нет запросов на выставление счета',
  cont_no_invoice_requests_desc: 'Здесь будет отображаться перечень ваших запросов на выставление счета',
  cont_invoice_number: 'Номер счета',
  cont_invoice_information: 'Информация о счете',
  cont_dispute_information: 'Информация о споре',
  cont_appeal_to_escrow: 'Обращение к Escrow',
  cont_resolve_the_dispute: 'Разрешить спор',
  cont_start_a_dispute: 'Начать спор',
  cont_confirm_the_payment: 'Подтвердите платеж',
  cont_create_invoice: 'Создать новый счет',
  cont_invoices: 'Счета',
  cont_invoice_amount: 'Количество %{asset}',
  cont_email_invalid: 'Неверный Email контрагента',
  cont_counterparty_invalid: 'Неверное название контрагента',
  cont_pending_status: 'В ожидании подписи со стороны контрагента',
  cont_type_outgoing: 'Исходящий',
  cont_type_incoming: 'Входящий',
  cont_sign: 'Подписать',
  contract_signed: 'Контракт подписан',
  contract_rejected: 'Контракт отклонен',
  contract_completed: 'Контракт составлен',
  cont_invoice_confirmed: 'Счет подтвержден',
  cont_invoice_rejected: 'Счет отклонен',
  cont_contract_confirmed: 'Платежи по контракту подтверждены',
  cont_confirm_completed: 'Подтверждение выполнено',
  cont_dispute_submitted: 'Спор передан на рассмотрение',
  cont_invoice_created: 'Счет отправлен',
  cont_appeal_success: 'Апелляция к условному депонированию успешно отправлена',
  cont_appeal_escrow_by: 'Обращение к условному депонированию',
  cont_escrow_resolution: 'Разрешение сделки',
  // company_view
  com_all: 'Все',
  com_upcoming_only: 'Запланирована',
  com_live: 'Активна',
  com_closed: 'Завершена',
  com_state_as_status: 'Статус',
  com_search: 'Искать краудфандинговый проект',
  com_sort_launch_date: 'Дате запуска',
  com_sort_soonest: 'Сроку окончания',
  com_sort_popularity: 'Популярности',
  com_no_sales_found: 'Мы не нашли проект с похожим названием',
  com_no_sales_found_desc: 'Проверьте написание, попробуйте поискать по коду актива или используйте фильтры',
  com_name: 'Название компании',
  com_date_of_foundation: 'Дата основания',
  com_homepage: 'Домашняя страница',
  com_industry_tags: 'Отрасль / Метки',
  com_team_size: 'Размер команды',
  com_type: 'Тип компании',
  com_headquarters: 'Главный офис',
  com_email: 'Email компании',
  com_website: 'Вебсайт компании',
  com_earned: 'Собрано',
  com_target: 'Цель сбора',
  com_profitability: 'Доходность',
  com_investors: 'Инвесторы',
  com_campaign: 'Проект',
  // dashboard_view
  dash_activity: 'Последняя активность',
  dash_wallet: 'Ваш кошелек',
  total_wallet: 'Всего',
  gray_wallet: 'Серая',
  white_wallet: 'Белая',
  dash_verification: 'Пройдите верификацию, чтобы получить доступ ко всем функциям платформы',
  dash_verification_wait: 'Ваши документы еще находятся на рассмотрении',
  // fees
  fees_your_fees: 'Комиссии вашего актива %{asset} ',
  fees_asset: 'Актив',
  fees_payment_fee: 'Комиссия за платеж',
  fees_offer_fee: 'Предложенная комиссия',
  fees_withdrawal_fee: 'Комиссия за вывод',
  fees_issuance_fee: 'Комиссия за эмиссию',
  fees_invest_fee: 'Комиссия за инвестирование',
  fees_incoming_outgoing: 'Входящий и исходящий',
  fees_outgoing: 'Исходящий',
  fees_incoming: 'Входящий',
  fees_fee_type: 'Тип комиссии',
  fees_fixed: 'Фиксированная',
  fees_percent: 'Процент',
  fees_lower_bound: 'Нижняя граница',
  fees_upper_bound: 'Верхняя граница',
  fees_subtype: 'Подтип',
  fees_percent_fixed: 'Комиссия: %{percent}% + %{fixed} %{currency}',
  fees_will_charged: 'Со счета будет списано %{willCharged} %{currency}',
  fees_load_fail: 'Не удалось загрузить комиссии',
  lbl_fees_label: 'Комиссия',
  // file-upload
  max_file_size_exceeded: 'Максимальный размер файла составляет %{size} Мб. Пожалуйста, загрузите файл меньшего размера',
  min_file_size_fail: 'Минимальный размер файла составляет %{size} Мб. Пожалуйста, загрузите файл большего размера',
  min_image_width_fail: 'Ширина изображения должна быть больше чем %{width}',
  min_image_height_fail: 'Высота изображения должна быть больше чем %{height}',
  min_image_dimension_fail: 'Ширина и высота изображения должны быть больше чем %{width}x%{height}',
  unsupported_extension: 'Извините, %{ext} не поддерживается',
  max_size: 'Макс. размер %{size} Мб',
  fi_no_file_chosen: 'Файл не выбран',
  fi_upload_file: 'изображение или pdf (мaкс. размер %{size} Мб)',
  fi_view_file: 'Просмотреть файл',
  fi_upload_iss_file: 'Файл для предэмиссии актива',
  fi_upload_csv_file: 'Выбрать файл(ы) (до %{size} мб)',
  file_incorrect_type: 'Некорректный формат файла',
  // inactivity_message
  inm_session_timeout: 'Время сессии исткело',
  inm_session_timeout_descr: 'Время сессии истекло из-за продолжительного отсутствия деятельности',
  // labels
  signup_password: '"пароль"',
  lbl_import_image_details: 'Минимальный размер: 120х120, не более 5 МБ\nПоддерживаемые форматы: PNG, JPG, GIF, BMP',
  lbl_import_image_details_campaign: 'Минимальный размер: 290х170, не более 5 МБ\nПоддерживаемые форматы: PNG, JPG, GIF, BMP',
  lbl_confirmation_sent: 'Письмо с подтверждением было отправлено на ящик %{mail}. Пожалуйста, проверьте почту и подтвердите, что она ваша.',
  lbl_check_spam: 'Если вы не получили письма с подтверждением, проверьте папку со спамом.',
  lbl_seed_dont_match: 'Seed-фраза введена с ошибками',
  lbl_select_files: 'Выбрать файл(ы)',
  lbl_contact_us: 'Свяжитесь с нами',
  lbl_transactions: 'Транзакции',
  lbl_dashboard: 'Домой',
  lbl_history_menu: 'История',
  lbl_investment_portfolio: 'История инвестиций',
  lbl_portfolio_investments: 'История инвестиций',
  lbl_investment: 'Инвестиции',
  lbl_available: 'Доступно',
  lbl_locked: 'Заблокировано',
  lbl_current_price: 'Текущая цена:',
  lbl_exchange_rates: 'Курсы валют по отношению к %{asset}',
  lbl_no_investment_tokens: 'вашем портфолио нет инвестиционных токенов',
  lbl_no_investment_tokens_desc: 'Тут будет список ваших инвестиционных токенов',
  lbl_user_info: 'Данные пользователя',
  lbl_email: 'Email',
  lbl_pwd: 'Пароль',
  lbl_new_pwd: 'Новый пароль',
  lbl_pwd_confirm: 'Подтвердите пароль',
  lbl_confirm: 'Подтвердить',
  lbl_asset: 'Актив',
  lbl_create_wallet: 'Созлать кошелек',
  lbl_choose_asset: 'Выберите актив',
  lbl_amount: 'Сумма',
  lbl_give: 'Отдаю',
  lbl_get: 'Получаю',
  lbl_almost_done: 'Почти готово',
  lbl_request_new_email: 'Запросить письмо заново',
  lbl_settings: 'Настройки',
  lbl_verification: 'Верификация',
  lbl_acc_verification: 'Верификация аккаунта',
  lbl_help: 'Помощь',
  lbl_signout: 'Выйти',
  lbl_signin: 'Войти',
  lbl_signup: 'Зарегистрироваться',
  lbl_logout: 'Выйти',
  lbl_zeros: 'Скрыть нулевые балансы',
  lbl_my_account: 'Моя учетная запись',
  lbl_account: 'Учетная запись',
  lbl_account_info: 'Учетная запись',
  lbl_account_type: 'Тип аккаунта',
  lbl_taurus_id: 'UPLATA карта',
  lbl_uplata_insha_name: 'Visa Iнша',
  lbl_uplata_insha: 'Карты Visa Iнша',
  lbl_no_uplata_insha: 'Карты Visa Iнша отсутствуют',
  lbl_no_xpay: 'Карты отсутствуют',
  lbl_xpay: 'Платежные карты',
  lbl_no_card: 'Карта не выбрана',
  lbl_add_xpay: 'Введите номер платежной карты для добавления',
  lbl_invalid_uplata_len: '16-ти значный номер',
  lbl_add_uplata_insha: 'Номер карты Visa Iнша',
  lbl_taid: 'Карты UPLATA',
  lbl_no_taid: 'Карты UPLATA отсутствуют',
  lbl_invalid_taid_len: 'введите 7-ми значный номер',
  lbl_add_taurus: 'Номер карты UPLATA',
  lbl_number_is_exists: 'Номер уже есть в списке карт',
  lbl_auto_withdraw: 'автовывод',
  lbl_delete_confirm_title: 'Подтверждение удаления',
  lbl_delete: 'Удалить',
  lbl_card_add: 'Добавить карту',
  lbl_card_delete: 'удалить карту',
  lbl_id_delete_confirm: 'Вы действительно хотите удалить карту %{id} ?',
  lbl_id_add_confirm: 'Вы действительно хотите добавить карту %{id} ?',
  lbl_autowithdraw_confirm: 'Вы действительно хотите изменить параметры автовывода?',
  lbl_exchange: 'Обмен',
  lbl_verified: 'Верифицированный пользователь',
  lbl_got_it: 'Понятно',
  lbl_unverified: 'Неподтвержденный пользователь',
  lbl_not_verified: 'не подтверждена',
  lbl_confirm_send: 'Подтвердить отправку',
  lbl_enter_quantity: 'Введите количество',
  lbl_back_to_sale: 'Вернуться к проекту',
  lbl_email_2: 'Почта',
  lbl_tokens_assets: 'Количество активов',
  lbl_accept: 'Подтверждаю',
  lbl_go_to_pay: 'Перейти к выплате',
  lbl_go_to_section: 'Перейдите в раздел ',
  lbl_pdf_5mb: 'Только формат PDF, не более 5 МБ',
  lbl_dividends_pay: 'Выплата дивидендов',
  lbl_publish_file: 'Опубликовать',
  lbl_copy: 'Скопировать',
  lbl_lost_2fa: 'Потерял 2FA',
  lbl_add_2fa: 'Добавить двухфакторную аутентификацию',
  lbl_recover_2fa: 'Восстановить двухфакторную аутентификацию',
  pending: 'ожидает верификации',
  approved: 'подтверждена',
  rejected: 'отклонена',
  tx_from: 'от',
  tx_to: 'исходящая',
  tx_issuance: 'Зачисление',
  tx_investment: 'Инвестиция',
  tx_match: 'Закрытие заявки',
  tx_withdrawal: 'Вывод',
  tx_transfer: 'Перевод',
  tx_offer: 'Предложение',
  tx_invoice: 'Инвойс',
  tx_state_confirm: 'успех',
  tx_state_success: 'успех',
  tx_state_failed: 'неудача',
  tx_state_rejected: 'отклонена',
  tx_state_pending: 'ожидается',
  tx_state_fully_matched: 'заявка закрыта',
  tx_greater_than_balance: 'Сумма превышает баланс',
  tx_blocks_separator: 'или',
  lbl_my_wallet: 'Кошелек',
  lbl_deposit: 'Зачислить',
  lbl_deposit_white: 'На белый кошелек',
  lbl_refund: 'Вернуть',
  lbl_reason: 'Причина',
  lbl_aml_title: 'Транзакция требует внимания',
  lbl_aml_title_large: 'Транзакция требует внимания. Обнаружены повышенные рисковые показатели или возникла ошибка обработки. Проверьте детали ниже и примите решение.',
  lbl_check_again: 'Проверить снова',
  lbl_withdraw: 'Вывод',
  lbl_refill: 'Пополнить',
  lbl_withdrawal_req: 'Заявки на вывод',
  lbl_refund_history: 'История возвратов',
  lbl_send: 'Отправить',
  lbl_send_immediatly: 'Отправить немедленно',
  lbl_send_mass: 'Массовый перевод',
  lbl_cashbox: 'Заявки в кассу',
  lbl_tokens: 'Токенизация',
  lbl_trade: 'Торговля',
  lbl_create_token: 'Создать токен',
  lbl_create_sale: 'Создать проект',
  lbl_creation_sale: 'Создание проекта',
  lbl_tokens_management: 'Управление токенами',
  lbl_explore_tokens: 'Доступные токены',
  lbl_explore_sales: 'Поиск проектов',
  lbl_my_funds: 'Мои проекты',
  lbl_history: 'История транзакций',
  lbl_history_w: 'История выводов',
  lbl_history_e: 'История пополнений',
  lbl_business_directory: 'Каталог проектов',
  lbl_cancel: 'Отмена',
  lbl_withdrawal_cancel: 'Отменить вывод',
  lbl_approvers: 'Утверждающие',
  lbl_signatures: 'Подписи',
  lbl_level: 'Уровень',
  lbl_level_1: 'Операционист',
  lbl_level_2: 'Контролер',
  lbl_level_3: 'Руководитель напралвения',
  lbl_level_4: 'Директор',
  lbl_sub_transfer: 'Перевод',
  lbl_export: 'Экспорт',
  lbl_wallet: 'Кошелек',
  lbl_one_time_wallet: 'Кошелек одноразовый',
  lbl_client_wallet: 'Кошелек клиента',
  lbl_wallet_onetime: 'Одноразовый кошелек',
  lbl_something_wrong: 'что-то пошло не так, повторите попытку позже',
  lbl_enroll: 'Зачислить',
  lbl_put_aside: 'Отложить',
  lbl_check_crystal: 'Проверить вручную в Crystal',
  lbl_credit_dirty: 'На серый кошелек',
  lbl_main_user_id: 'Main user id',
  lbl_current_lvl: 'Ожидаемый уровень подписи',
  lbl_total_levels: 'Всего нужно уровней',
  lbl_user_id: 'ID пользователя',
  lbl_date: 'Дата',
  lbl_time_optional: 'Время',
  lbl_time_to_tx: 'Время до отправки транзакции',
  lbl_cancel_refund: 'Отменить возврат',
  lbl_time_to_refund: 'Вы можете отменить возврат, пока не завершится отсчет таймера',
  lbl_id: 'ID',
  lbl_temporary_wallet: 'Временный кошелек',
  lbl_refund_amount: 'Сумма возврата',
  lbl_address: 'Адрес',
  lbl_address_refund: 'Адрес возврата',
  lbl_commision: 'Комиссия',
  lbl_refund_address: 'Адрес возврата',
  lbl_sum_refund: 'Сумма возврата',
  lbl_refund_canceled: 'Ошибка',
  lbl_refund_success: 'Успех',
  lbl_refund_pending: 'Ожидается',
  lbl_refund_balance: 'Баланс',
  lbl_refund_asset: 'Валюта',
  lbl_refund_date: 'Дата создания',
  lbl_refund_hash: 'Хэш',
  lbl_refund_status: 'Статус',
  lbl_refund_number: 'Номер заявки',
  lbl_to_app: 'К приложению', // назад к приложению
  lbl_hash: 'Хэш',
  lbl_client_hash: 'Хэш клиента',
  lbl_order_id: 'Номер заявки',
  lbl_order_uid: 'ID заявки',
  lbl_internal_hash: 'Внутренний хэш',
  lbl_order_amount: 'Сумма по заявке',
  lbl_order_network: 'Сеть по заявке',
  lbl_tx_type: 'Тип транзакции',
  lbl_status: 'Статус',
  lbl_my: 'Доступные заявки',
  lbl_pending: 'Ожидается',
  lbl_aml_pending: 'Ожидается AML проверка',
  lbl_confirmed: 'Подтверждено',
  lbl_canceled: 'Отменено',
  lbl_check_sign: 'Ожидает подписания',
  lbl_check_sign_again: 'Проверить снова',
  lbl_balance: 'Баланс',
  lbl_counterparty: 'Контрагент',
  lbl_sender: 'Отправитель',
  lbl_receiver: 'Получатель',
  lbl_fixed_fee: 'Фиксированная комиссия',
  lbl_percent_fee: 'Процентная комиссия',
  lbl_total_fee: 'Общая комиссия',
  lbl_add_note: 'Добавить описание',
  lbl_description: 'Описание',
  lbl_client: 'Клиент',
  lbl_direction_group: 'Група направления',
  lbl_client_group: 'Группа клиента',
  lbl_fund_name: 'Название проекта',
  lbl_sale_name: 'Название проекта',
  lbl_exchange_asset: 'Валюта',
  lbl_limit_title: 'Лимит пополнения',
  lbl_limit_s: 'Сумма ниже минимального лимита пополнения',
  lbl_exchange_buy: 'Покупка',
  lbl_exchange_sell: 'Продажа',
  lbl_base_asset: 'Базовый актив',
  lbl_default_quote_asset: 'Котируемая валюта',
  lbl_fee_paid: 'Комиссия оплачена',
  lbl_price: 'Цена',
  lbl_transfer_fee: 'Комиссия за перевод',
  lbl_destination_asset: 'Целевой актив',
  lbl_destination_amount: 'Целевая сумма',
  lbl_source_amount: 'Заявленная сумма',
  lbl_ok: 'Ок',
  lbl_tfa_code: '2FA код',
  lbl_add: 'Добавить',
  lbl_add_more: 'Добавить еще',
  lbl_added_video: 'Добавленные видео:',
  lbl_submit: 'Принять',
  lbl_secret: 'Секретное слово',
  lbl_recovery_seed: 'Код для восстановления',
  lbl_transaction_details: 'Детали транзакции',
  lbl_view_more: 'Смотреть больше',
  lbl_all_history: 'Вся история',
  lbl_all: 'Все',
  lbl_mine: 'Мои',
  lbl_close: 'Отмена',
  lbl_recipient_email_or_account: 'Email получателя или ID учетной записи',
  lbl_recipient_email: 'Email получателя',
  lbl_recipient: 'Получатель',
  lbl_recipient_account_id: 'ID учетной записи получателя',
  lbl_recipient_balance_id: 'ID баланса получателя',
  lbl_requestor: 'Контрагент',
  lbl_requestor_account_id: 'ID учетной записи контрагента',
  lbl_requestor_id_or_email: 'ID или email контрагента',
  lbl_recipient__email: 'Email получателя',
  lbl_source_fees: 'Комиссии отправителя',
  lbl_fixed_percent: '(Фиксированный/процент)',
  lbl_destination_fees: 'Системный сбор',
  lbl_recipient_fixed_fee: 'Фиксированная комиссия получателя',
  lbl_recipient_percent_fee: 'Процентный сбор получателя',
  lbl_sender_balance_id: 'ID баланс получателя',
  lbl_sender_fixed_fee: 'Фиксированная комиссия получателя',
  lbl_sender_percent_fee: 'Процентный сбор получателя',
  lbl_fixed: 'Фикс.',
  lbl_percent: 'Процент',
  lbl_subject: 'Предмет',
  lbl_token_code: 'Код токена',
  lbl_token_name: 'Название токена',
  lbl_token_icon: 'Загрузить иконку',
  lbl_token_terms: 'Загрузить условия',
  lbl_token_preissued_asset_signer: 'Подписант предэмиссии актива',
  lbl_token_max_issuance_amount: 'Максимальная сумма эмиссии',
  lbl_token_policies: 'Политика',
  lbl_token_initial_preissued_amount: 'Начальная сумма предэмиссии',
  lbl_is_transferable: 'Создать передаваемый актив',
  lbl_is_additional_issuance_allowed: 'Позволена дополнительная эмиссия',
  lbl_is_tradable: 'Торгуемый',
  lbl_fees: 'Комиссия',
  lbl_sender_fees: 'Комиссии отправителя',
  lbl_recipient_fees: 'Комиссии получателя',
  lbl_go_back: 'Вернуться',
  lbl_delete_notif: 'Удалить это уведомление',
  lbl_go_back_2: 'Назад',
  lbl_make_recovery: 'Восстановить',
  lbl_validate_seed: 'Введите seed-фразу',
  lbl_seed: 'Seed-фраза',
  lbl_first_name: 'Имя',
  lbl_last_name: 'Фамилия',
  lbl_line_1: 'Строка 1',
  lbl_line_2: 'Строка 2',
  lbl_city: 'Город',
  lbl_country: 'Страна',
  lbl_state: 'Статус',
  lbl_postal_code: 'Почтовый индекс',
  lbl_kyc: 'Учетная запись пользователя',
  lbl_kyc_photo: 'Фото',
  lbl_kyc_selfie: 'Снимок с проверочным кодом',
  lbl_kyc_id: 'Документ удостоверения личности',
  lbl_kyc_proof: 'Подтверждение адреса',
  lbl_done: 'Готово',
  lbl_date_of_birth: 'Дата рождения',
  lbl_id_document_exp_date: 'Срок действия удостоверения личности',
  lbl_code: 'Код',
  lbl_document_type: 'Тип документа',
  lbl_owner: 'Владелец',
  lbl_avalilable_for_iss: 'Доступно',
  lbl_name: 'Название',
  lbl_signer: 'Подписант',
  lbl_maximum: 'Максимум',
  lbl_max_issuance: 'Максимум',
  lbl_issued: 'Выпущено',
  lbl_policy: 'Политика',
  lbl_policies: 'Политики',
  lbl_terms: 'Условия',
  lbl_token_details: 'Детали токена',
  lbl_add_to_balances: 'Добавить на мой счет',
  lbl_balance_exists: 'Добавлен в кошелек',
  lbl_view_history: 'Посмотреть историю',
  lbl_user: 'Пользователь',
  lbl_sub: 'Суб аккаунт',
  lbl_new: 'Новый',
  lbl_new_dir: 'Новое направление',
  lbl_new_client: 'Новый клиент',
  lbl_sub_edit: 'Редактировать',
  lbl_subs: 'Суб аккаунты',
  lbl_direction: 'Направление',
  lbl_no_wallets: 'Нет субаккаунтов для этой валюты',
  lbl_no_funds: 'Нераспределенные средства',
  lbl_aml_notify: 'Aml нотификации',
  lbl_aml_notify_inc: 'Входящие — уведомления AML',
  lbl_aml_notify_out: 'Исходящие — уведомления AML',
  lbl_aml_error_out: 'Исходящие — уведомления об ошибках AML',
  lbl_aml_error_inc: 'Входящие — уведомления об ошибках AML',
  lbl_manual_aml_review: 'На ручной AML проверке',
  lbl_lymit_notify: 'Лимитные нотификации',
  lbl_inc_notify: 'Входящие нотификации',
  lbl_out_notify: 'Исходящие нотификации',
  lbl_group_name: 'Группировать по клиенту',
  lbl_group_decs: 'Группировать по направлению',
  lbl_add_group_decs: 'Дополнительно группировать по направлению',
  lbl_add_group_client: 'Дополнительно группировать по клиенту',
  lbl_group_add: 'все',
  lbl_userBlocked: 'Пользователь заблокирован',
  lbl_requests: 'Запросы',
  lbl_fee: 'Комиссии',
  lbl_giftmall: 'Магазин',
  lbl_request_state: 'Состояние запроса',
  lbl_token_creation: 'Создание токена',
  lbl_sale_creation: 'Создание проекта',
  lbl_manual_issuance: 'Ручная эмиссия',
  lbl_token_creation_requests: 'Запросы на создание токена',
  lbl_choose_image: 'Выберите изображение с вашего устройства',
  lbl_chose_image_token: 'Перетащите сюда изображение,<br> которое станет логотипом вашего актива',
  lbl_chose_image_campaign: 'Перетащите сюда изображение,<br> которое станет превью вашего проекта',
  lbl_no_token_creation_requests: 'Нет запросов на создание токена',
  lbl_no_token_creation_requests_desc: 'Здесь будет отображаться список ваших запросов на создание токена',
  lbl_created_at: 'Дата создания',
  lbl_revoked: 'Отозвано',
  lbl_updated_at: 'Обновлен в',
  lbl_update: 'Обновить',
  lbl_reference: 'Ссылка',
  lbl_view_sale: 'Посмотреть проект',
  lbl_create_issuance: 'Создать эмиссию',
  lbl_sender_fee: 'Комиссия отправителя',
  lbl_recipient_fee: 'Комиссия получателя',
  lbl_fee_from_source: 'Комиссия оплачена отправителем',
  lbl_sender_fee_asset: 'Комиссия отправителя',
  lbl_recipient_fee_asset: 'Комиссия получателя',
  lbl_sort_by: 'Сортировать по',
  lbl_reject_message: 'Отклонить сообщение',
  lbl_information: 'Информация',
  lbl_not_available: 'Пожалуйста, подождите',
  lbl_token_not_available_exp: 'Создавать токены могут только корпоративные пользователи.\nЧтобы стать корпоративным пользователем, пройдите верификацию.',
  lbl_token_not_available_yet: 'Пожалуйста, создайте токен, перед тем, как создавать проект',
  lbl_issuance_not_available_exp: 'Эмиссию могут производить только корпоративные пользователи. Чтобы стать корпоративным пользователем, пройдите верификацию.',
  lbl_issuance_not_available_yet: 'Пожалуйста, создайте токен прежде чем производить эмиссию',
  lbl_preissuance_not_available_exp: 'Загрузка файла для предэмиссии доступна только для корпоративных пользователей. Чтобы стать корпоративным пользователем, пройдите верификацию.',
  lbl_not_available_exp: '% {screen} доступен только для верифицированных пользователей. Пройдите, пожалуйста, верификацию.',
  lbl_upload_preissuance: 'Создать предэмиссию',
  lbl_clear: 'Очистить',
  lbl_upload: 'Загрузить',
  lbl_company: 'Компания',
  lbl_headquarters: 'Главный офис',
  lbl_industry: 'Отрасль',
  lbl_founded: 'Дата основания',
  lbl_team_size: 'Размер команды',
  lbl_homepage: 'Домашняя страница',
  lbl_edit_details: 'Редактировать детали',
  lbl_loading: 'Загрузка...',
  lbl_your_wallet: 'Ваш кошелёк',
  lbl_one_time_wallet_address: 'Адрес одноразового кошелька',
  lbl_wait_30: 'Пожалуйста, используйте адрес одноразового кошелька ниже только пока не завершится отсчет таймера',
  lbl_timer_error: 'что-то пошло не так, перезагрузите страницу',
  lbl_create_btn: 'Новое пополнение',
  lbl_no_data: 'Нет данных',
  lbl_to_upload: 'Для загрузки:',
  lbl_street_name: 'Название улицы',
  lbl_upload_docs: 'Пожалуйста, загрузите следующие документы',
  lbl_upload_doc: 'Пожалуйста, загрузите следующий документ',
  lbl_agree_submit: 'Согласен и подтверждаю информацию',
  lbl_pay_all_fees: 'Оплата комиссии',
  lbl_residence_country: 'Страна проживания',
  lbl_zip_code: 'Почтовый индекс',
  lbl_limits: 'Лимиты',
  lbl_note: 'Примечание',
  lbl_send_request: 'Отправить запрос',
  lbl_to: 'Кому',
  lbl_request_type: 'Тип запроса',
  lbl_more: 'Больше',
  lbl_upload_documents: 'Загрузить документы',
  lbl_request_creation_date: 'Дата создания запроса',
  lbl_requesting: 'Запрос',
  lbl_contracts: 'Контракты',
  lbl_market: 'Маркет',
  lbl_start_date: 'Дата начала',
  lbl_end_date: 'Дата завершения',
  lbl_yes: 'Да',
  lbl_no: 'Нет',
  lbl_documents: 'Документы',
  lbl_document: 'Документ',
  lbl_submitted_by: 'Представлено',
  lbl_type: 'Тип',
  lbl_archive: 'Архив',
  lbl_reject: 'Отклонить',
  lbl_funds: 'Проекты',
  lbl_projects: 'Проекты',
  lbl_open: 'Открыть',
  lbl_reject_request: 'Запрос отклонен',
  lbl_reject_reason: 'Причина отказа',
  lbl_contracts_not_available_exp: 'Контракты доступны только для верифицированных пользователей. Пройдите, пожалуйста, верификацию.',
  lbl_see_details_in_contract: 'Смотрите детали в контракте.',
  lbl_invoice_number: 'Номер инвойса',
  lbl_card_add_uplata: 'Введите Uplata TaID для добавления карты',
  lbl_current_balance: 'Ваш баланс: %{amount} %{asset}',
  lbl_sub_current_balance: 'Баланс суб кошелька: %{amount} %{asset}',
  lbl_campaign_status: 'Статус проекта',
  lbl_search_campaign: 'Поиск по названию проекта...',
  lbl_search_btn: 'Найти',
  lbl_from: 'От',
  lbl_history_btn: 'История делегирований',
  lbl_delegate_btn: 'Делегировать',
  lbl_return_btn: 'Отозвать',
  lbl_delegate_text: 'Вы делегировали свои права',
  lbl_delegated_to_you: 'Вам были делегированы права от %{user} ваш уровень сейчас %{level} заканчивается %{date}',
  lbl_status_open: 'активна',
  lbl_status_canceled: 'отменена',
  lbl_status_closed: 'завершена',
  lbl_month: 'месяц',
  lbl_months: 'месяца',
  lbl_months_2: 'месяцев',
  lbl_back_to_settings: 'Вернуться к настройкам',
  lbl_choose_account_type: 'Выберите тип аккаунта',
  lbl_confirmation: 'Подтверждение',
  lbl_to_dashboard: 'На главную',
  lbl_notifications: 'Уведомления',
  lbl_continue: 'Продолжить',
  // limits_view
  lim_limits: 'Лимиты',
  lim_limits_requests: 'Список запросов',
  lim_imposed_on: 'Введенный в отношении ',
  lim_one_time: 'Единоразовый лимит',
  lim_daily: 'Дневной лимит',
  lim_weekly: 'Недельный лимит',
  lim_monthly: 'Месячный лимит',
  lim_annual: 'Годовой лимит',
  lim_daily_left: 'Дневной лимит остаток:',
  lim_weekly_left: 'Недельный лимит остаток:',
  lim_monthly_left: 'Месячный лимит остаток:',
  lim_annual_left: 'Годовой лимит остаток:',
  lim_left_total: '(Использовано/всего)',
  lim_upload_poi: 'Загрузить подтверждение дохода',
  lim_poi: 'Подтверждение дохода',
  lim_requested: 'Запрос успешно отправлен',
  lim_date: 'Дата',
  lim_request_id: 'ID запроса',
  lim_state: 'Состояние',
  lim_asset: 'Актив',
  lim_proof: 'Подтверждение дохода',
  lim_heading: 'Лимиты, введенные в отношении учетной записи',
  lim_left: 'Осталось',
  lim_total: 'Всего',
  lim_spent: 'Потрачено',
  lim_change_limits: 'Изменить лимиты',
  lim_change_limits_title: 'Изменить лимиты - %{assetName} (%{asset})',
  lim_no_changing_requests: 'Нет запросов на изменение лимитов',
  lim_no_changing_requests_desc: 'Здесь будет отображаться список ваших запросов на изменение лимитов',
  lim_transaction_type_title: 'Тип транзакции',
  lim_requirements_title: 'Требования',
  lim_pending_request_msg: 'Ваш запрос ожидает рассмотрения администратором',
  lim_upload_documents_btn: 'Загрузить документы',
  lim_operation_type_limit_label: 'Выбрать тип лимита',
  limit_daily_validation_msg: 'Пожалуйста, установите дневной лимит',
  limit_weekly_validation_msg: 'Пожалуйста, установите недельный лимит',
  limit_monthly_validation_msg: 'Пожалуйста, установите месячный лимит',
  limit_validation_msg: 'Пожалуйста, установите лимиты',
  limit_daily_fall_behind_msg: 'Дневной лимит не может быть ниже 0',
  limit_weekly_fall_behind_msg: 'Недельный лимит не может быть ниже 0',
  limit_monthly_fall_behind_msg: 'Месячный лимит не может быть ниже 0',
  limit_annual_fall_behind_msg: 'Годовой лимит не может быть ниже 0',
  limit_monthly_exceed_msg: 'Месячный лимит не может превышать годовой лимит',
  limit_weekly_exceed_msg: 'Недельный лимит не может превышать месячный лимит',
  limit_daily_exceed_msg: 'Дневной лимит не может превышать недельный лимит',
  lim_transaction_type: 'Тип транзакции',
  lim_requirements: 'Требования',
  lim_withdrawal_daily_msg1: 'ВНИМАНИЕ! Сумма платежа не может превышать %{limit} %{asset}.',
  lim_withdrawal_daily_msg2: 'Общая сумма за рабочий (банковский) день не может превышать %{limit} %{asset}.',
  lim_withdrawal_daily_msg3: 'Праздничные и выходные дни считаются как единый банковский день со следующим рабочим днем.',
  // login_view
  log_signin: 'Войти',
  log_dont_have_an_account: 'У вас нет учетной записи?',
  log_register_now: 'Зарегистрироваться сейчас',
  log_forgot_password: 'Забыли пароль?',
  log_recover_it: 'Восстановить',
  // modals
  mod_pwd_wrond: 'Неправильный пароль',
  mod_pwd_required: 'Введите текущий пароль',
  mod_tfa_required: 'Необходима 2-х факторная аутентификация',
  mod_save_seed: 'Это Ваша seed-фраза.',
  mod_save_seed_subtitle: 'Она понадобится для восстановления доступа, если Вы забудете или потеряете пароль. Обязательно сохраните seed-фразу в надежном месте.',
  mod_why_save_seed: 'Для безопасности, пожалуйста, запишите этот код в каком-то секретном месте.\nОн понадобится вам для восстановления доступа к вашей учетной записи.',
  mod_validate_seed_how: 'Пожалуйста, скопируйте ее также в поле ниже:',
  mod_confirm_title: 'Вы уверены?',
  mod_withdrawal_confirm_title: 'Вы уверены, что хотите отменить транзакцию вывода?',
  mod_withdrawal_confirm_message: 'Средства вернутся на баланс.',
  mod_confirm_message: 'Перед тем, как продолжить, пожалуйста, подтвердите это действие',
  mod_confirm_confirm_text: 'Подтверждаю',
  mod_confirm_cancel_text: 'Закрыть',
  mod_email_not_verified_title: 'Email не подтвержден',
  mod_email_not_verified_message: 'Похоже, что ваш email еще не подтвержден. Пожалуйста, проверьте папку "Спам" или запросите новое письмо, нажав "Подтверждаю"',
  mod_accountBlocked_title: 'Учетная запись заблокирована',
  mod_accountBlocked_message: 'Вы больше не можете делать транзакции',
  mod_under_construct_title: 'Эта страница временно находится в разработке',
  mod_under_construct_text: 'Если у вас возникли какие-то вопросы, то напишите в поддержу — мы поможем решить ваши проблемы',
  mod_empty_fund_logo: 'Добавьте логотип или видео для превью Вашего проекта',
  mod_empty_fund_description: 'Добавьте описание проекта',
  mod_empty_token_logo: 'Добавьте логотип Вашего актива',
  mod_confirm_seed: 'Ваш аккаунт заблокирован. Вы не можете выполнять операции. Пожалуйста, введите Seed-фразу, чтобы разблокировать ваш аккаунт.',
  mod_confirm_seed_login: 'Ваш аккаунт заблокирован. Пожалуйста, введите Seed-фразу, чтобы разблокировать ваш аккаунт.',
  // sale_view
  sale_enable_time_spec: 'Указывать дату и время',
  sale_start_time: 'Дата начала',
  sale_start_time_now: 'После подтверждения',
  sale_start_time_set: 'Указать дату',
  sale_close_time: 'Дата окончания',
  sale_close_time_manual: 'Возможность закрыть до срока',
  sale_soft_cap_with_asset: 'Минимальный порог (%{asset})',
  sale_soft_cap: 'Soft cap',
  sale_hard_cap_with_asset: 'Максимальный порог (%{asset})',
  sale_hard_cap: 'Hard cap',
  sale_base_asset_for_hard_cap: 'Базовый актив для достижения максимального порога',
  sale_base_asset_hard_cap_to_sell: '%{asset} для продажи',
  sale_provide_information: 'Предоставьте информацию о проекте',
  sale_description_step: 'Описание',
  sale_next_step: 'Следующий шаг',
  sale_short_blurb: 'Короткая реклама',
  sale_description_label: 'Описание (до 250 символов)',
  sale_full_description: 'Полное описание',
  sale_tell_about_fund: 'Расскажите людям о вашем проекте',
  sale_project_information: 'Введите информацию о проекте',
  sale_create_sale: 'Создать проект',
  sale_in_process_of_creation: 'В процессе создания',
  sale_open_requests: 'Запросы на октрытие проекта',
  sale_start_new_sale: 'Начать новый проект',
  sale_quote_assets: 'Принимать инвестиции в:',
  sale_confirm: 'Пожалуйста, подтвердите создание проекта',
  sale_get_asset: 'В %{asset}',
  sale_invest_asset: 'Инвестировать %{asset}',
  sale_offer_created: 'Инвестирование прошло успешно. %{asset} будет добавлен в ваш кошелек, когда проект будет успешно завершен',
  sale_offer_cancelled: 'Ваша инвестиция в %{asset} закрылась успешно.',
  sale_offer_cancel: 'Закрыть предложение',
  sale_offer_cancel_tip: 'Текущая сумма инвестиции: %{amount} %{asset}',
  sale_token_sale_agreement: 'Просмотреть соглашение кампании токена',
  sale_by_owner: 'продавец %{owner}',
  sale_invest: 'Инвестировать',
  sale_investing: 'Инвестируя',
  sale_tip: 'Токены будут изданы только когда цель проекта достигнет %{endTime}',
  sale_corporate_details: 'Корпоративные детали',
  sale_crowdfund_team: 'Команда сбора средств',
  sale_crowdfund_leader: 'Лидер сбора средств',
  sale_accept_investments: 'Пожалуйста, выберите актив(ы), в которых вы принимаете инвестиции',
  sale_disable_invest_owners: 'Владельцы проекта не могут инвестировать в свои проекты',
  sale_disable_invest_hardcap_exceed: 'Сумма инветсиций достигла максимального порога: %{amount}',
  sale_disable_invest_upcoming_sale: 'Не стартовавшие проекты не подлежат инвестированию',
  sale_disable_invest_closed_sale: 'Закрытые проекты не подлежат инвестированию',
  sale_disable_invest_canceled_sale: 'Закрытые проекты не подлежат инвестированию',
  sale_state: 'Состояние проекта',
  sale_not_available_exp: 'Создавать проекты могут только корпоративные пользователи. Пройдите, пожалуйста, верификацию.',
  sale_nothing_found: 'Ничего не найдено',
  sale_no_created_sales: 'Вы еще не создали ни одного проекта.',
  sale_create_request_success: 'Информация загружена. Пожалуйста, дождитесь подтверждения',
  sale_offer_overlap: 'При создании нового предложения старое предложение будет обновлено',
  sale_max_invest: 'Установить максимальную сумму для инвестирования',
  sale_creation_requests: 'Запросы на создание проекта',
  sale_no_creation_requests: 'Нет запросов на создание проекта',
  sale_no_creation_requests_desc: 'Здесь будет список ваших запросов на создание проектов',
  sale_short_description: 'Краткое описание',
  sale_fund_video: 'Видео о проекте',
  sale_investments: 'Инвестиции',
  sale_investment_history: 'История инвестиций',
  sale_company_status_active: 'Активна',
  sale_company_status_completed: 'Завершена',
  sale_company_info: 'Информация о проекте',
  sale_collected: 'Собрано',
  sale_purpose_collection: 'Цель сбора',
  sale_remains_to_collect: 'Осталось собрать',
  sale_until_the_end: 'До окончания проекта',
  sale_campaign_type: 'Тип проекта',
  sale_sales_share: 'Доля продажи',
  sale_profitability: 'Доходность',
  sale_fixed_annual_arrive: 'Фиксированная годовая прибыль',
  sale_campaign_duration: 'Срок проекта',
  sale_minimum_investment: 'Минимальная инвестиция',
  sale_confirm_upload_ttl: 'Важно',
  sale_confirm_upload: 'Пожалуйста, убедитесь, что Ваш документ актуален и действителен. Он будет общедоступен, и любой пользователь сможет его загрузить. Документы могут быть удалены при необходимости.',
  sale_upload_success: 'Документ успешно загружен',
  sale_doc_tab_title_is_my: 'Действующие юридические документы укрепляют доверие инвесторов к Вашей компании',
  sale_doc_tab_docs_is_my: 'Здесь будет отображаться список загруженных документов',
  sale_upd_tab_add_update: 'Добавьте обновление в график',
  sale_upd_tab_add_timeline: 'Добавьте заметку к графику',
  sale_upd_tab_share_updates: 'Поделитесь своими обновлениями со своими спонсорами и потенциальными инвесторами!',
  sale_upd_tab_important_updated: 'Важные обновления будут отображаться здесь',
  sale_upd_tab_warning: 'Вы не сможете отредактировать или удалить обновление позже',
  sale_new_update: 'Новое обновление',
  sale_investor_income: 'Доход инвестора',
  sale_project_name: 'Инвестиционный проект',
  sale_limit_exceeded: 'Превышен лимит',
  sale_tab_overview: 'Описание',
  sale_tab_details: 'Детали',
  sale_tab_token: 'Актив',
  sale_tab_video: 'Видео',
  sale_tab_updates: 'Обновления',
  sale_tab_documents: 'Документы',
  sale_tab_dividends: 'Дивиденды',
  sale_pay_dividends: 'Выплатить дивиденды',
  sale_payout_amount: 'Сумма выплаты',
  sale_token_holder: 'Владель токена',
  sale_balance: 'Баланс',
  sale_dividends: 'Дивиденды',
  sale_dividends_confirm_title: 'Выплатить дивиденды ?',
  sale_dividends_confirm_text: 'Подтвердите перевод выплат дивидентов отобранным получателям, на общую сумму %{amount} EUR. Выплата отправляется на карточку кампании.',
  sale_dividends_confirm_bt_confirm: 'Подтвердить',
  sale_dividends_confirm_bt_cancel: 'Отменить',
  sale_dividends_search_placeholder: 'Поиск по электронной почте ...',
  sale_type_fund: 'Тип проекта',
  sale_publication: 'Публикация',
  sale_choose_fund_type: 'Выберите тип проекта',
  sale_choose_fund_subtype: 'Инвестиционный подтип',
  sale_type_crowdinvesting: 'Краудинвестинговый',
  sale_type_crowdfunding: 'Краудфандинговый',
  sale_type_description: 'Выберите этот тип, если Вы хотите собрать средства',
  sale_type_description_investing: 'У вас серьёзная компания, которая нуждается в дополнительных инвестициях для развития',
  sale_subtype_description: 'Инвесторы получают обратно свои вложения + фиксированный годовой процент. Выплаты не зависят от вашей прибыли.',
  sale_subtype_description_equity: 'Классическая инвесторная система, где размер выплачиваемых дивиденов зависит от вашего дохода',
  sale_progress_value: 'Заполнено на %{progress}%',
  sale_subtype_deposit: 'Займ',
  sale_subtype_equity: 'Equity',
  sale_subtype_crowdfunding: 'Краудфандинг',
  sale_year_earn: 'Фиксированная годовая прибыль',
  sale_payout_frequency: 'Периодичность выплат',
  sale_payout_frequency_divid: 'Периодичность выплат дивидендов',
  sale_loan_term: 'Срок проекта, месяцы',
  sale_equity_reporting: 'Периодичность подачи финансовой отчетности PL',
  sale_start: 'Начало',
  sale_finish: 'Конец',
  sale_term_control: 'Срок управления активом',
  sale_term_control_description: 'После начала срока инвесторы имеют право требовать у вас возвращения тела инвестиции.',
  sale_term_control_description_2: 'В конце срока вы обязаны вернуть тело инвестиции всем инвесторам.',
  sale_early_exit: 'Условия раннего выхода — ставка дисконтирования',
  sale_recipient_email: 'Почта получателя',
  sale_deduction_percentage: 'Процент отчисления',
  sale_add_more_recipient: 'Добавить ещё',
  sale_campaign_settings: 'Настройки проекта',
  sale_your_fund_type: 'Ваш тип проекта',
  sale_campaign_start: 'Старт проекта',
  sale_campaign_finish: 'Финиш проекта',
  sale_campaign_time_description: 'Мы рекомендуем ставить срок проекта не меньше 2-3 недель — так её увидят больше инвесторов',
  sale_investment_asset: 'Валюта сбора инвестиций',
  sale_softcap_description: 'Soft cap — минимальный порог инвестиций, который должен достичь ваш проект.',
  sale_hardcap_description: 'Hard cap — максимальный порог инвестиций, при его достижении проект закрывается автоматически.',
  sale_collection_amount: 'Сумма сбора',
  sale_available_currencies: 'Доступные валюты для инвестиции',
  sale_available_currencies_description: 'Здесь вы выбираете в какой валюте инвесторы смогут инвестировать в ваш проект средства.',
  sale_available_currencies_description_2: 'Мы автоматически конвертируем сумму инвестиций. Например, если вы выбрали валютой сбора USD, а инвестор хочет инвестировать с помощью EUR, то мы конвертируем его инвестицию в USD, исходя из текущего курса.',
  sale_create_token: 'Создание актива',
  sale_token_logo_title: 'Логотип актива',
  sale_name_token_title: 'Придумайте название актива',
  sale_my_token: 'Мой актив',
  sale_token_code_title: 'Задайте уникальный код актива',
  sale_token_code_description: '— от 3 до 5 символов',
  sale_token_code_description_2: ' — только латиница и цифры',
  sale_token_for_sale: 'Количество активов для продажи',
  sale_campaign_name: 'Придумайте название для проекта',
  sale_campaign_name_label: 'Мой проект',
  sale_campaign_preview: 'Превью проекта',
  sale_campaign_description: 'Описание проекта',
  sale_add_video: 'Добавьте видео о проекте',
  sale_add_video_label: 'Ссылка на YouTube',
  sale_add_button: 'Выбрать файл',
  sale_publication_text_1: 'Ваш проект готов к публикации, нам только осталось его проверить',
  sale_publication_text_2: 'Вы можете вернуться на любой шаг и проверить внесённые данные.',
  sale_publication_text_3: 'После отправки на проверку администратору вы не сможете изменять данные. Поэтому мы рекомендуем всё перепроверить.',
  sale_publication_confirm: 'Отправить на проверку',
  sale_crowdfunding: 'Краудфандинг',
  sale_deposit: 'Краудинвестинг - Займ',
  sale_equity: 'Краудинвестинг - Equity',
  sale_video_title: 'Вставьте ссылку на видео, которое станет превью вашего проекта',
  sale_video_preview_error: 'Неккоректная ссылка на видео',
  sale_video_formats: 'Поддерживаемые сервисы: YouTube',
  sale_video_past: 'Вставьте ссылку сюда',
  sale_publication_btn: 'Публикация проекта',
  sale_period_month: 'Месяц',
  sale_period_quarter: 'Квартал',
  sale_period_half_year: 'Полугодие',
  sale_period_year: 'Год',
  sale_status_title: 'Отлично, мы уже проверяем ваш проект',
  sale_status_text_accent: 'Вы можете отслеживать статус вашей заявки в разделе «Мои проекты»',
  sale_status_text: 'Если вы выбрали дату старта после подтверждения, то мы опубликуем проект сразу после проверки.',
  sale_interest_description: 'Здесь мы объясняем пользователю что значит доходность и от чего зависит процент доходности инвестора',
  sale_interest_from: 'от',
  sale_interest_to: 'до',
  sale_interest_profitability: 'Interest Rate — Доходность',
  sale_to_end: '%{days} дня(ей) осталось',
  sale_ends_today: 'Завершается сегодня',
  sale_minimum_invest: 'Минимальная сумма инвестиции',
  sale_set_min_invest: 'Задайте минимальную сумму, которую ходите принимать от инвесторов.',
  sale_back_to_list: 'Вернуться к списку',
  sale_add_video_bt: 'Добавить видео',
  sale_add_update_bt: 'Добавить обновление',
  sale_upload_document_bt: 'Загрузить документ',
  sale_tab_documents_ismy_header: 'Здесь будут ваши документы, касающиеся работы проекта',
  sale_tab_documents_ismy_text: 'Инвесторы ценят прозрачность — делитесь с ними финансовыми отчётами, стратегией развития и другими важными документами',
  sale_tab_updates_ismy_header: 'Здесь будут ваши заметки об обновлении проекта',
  sale_tab_updates_ismy_text: 'Расскажите вашим инвесторам о новостях проекта — на какой он стадии, нужна ли вам дополнительная помощь или просто поблагодарите их за участие',
  sale_add_note_bt: 'Добавить запись',
  sale_video_empty_header: 'Здесь будет отображаться список загруженных видео',
  sale_invested_header: 'Ваша сумма инвестиции',
  sale_invested_closed_text: 'Инвестиции в закрытый проект не принимаются',
  sale_invested_amount_text: 'Ваша сумма инвестиции',
  sale_invested_change_amount_bt: 'Изменить сумму инвестиции',
  sale_invested_cancel_bt: 'Отменить инвестицию',
  sale_invested_block_header: 'Инвестирование',
  sale_invested_your_balance: 'Ваш баланс',
  sale_invested_your_profit: 'Ваша прибыль составит',
  sale_invested_is_upcoming: 'Не стартовавшие проекты не подлежат инвестированию',
  sale_invested_hard_cap_exceeded: 'Сумма инветсиций достигла максимального порога',
  sale_invested_is_closed: 'Закрытые проекты не подлежат инвестированию',
  sale_invested_is_canceled: 'Закрытые проекты не подлежат инвестированию',
  sale_invested_limit_exceeded: 'Превышен лимит',
  sale_profit_from_to: 'от %{from} до %{to}',
  sale_updates_header: 'Заголовок',
  sale_update_news: 'Краткое содержание новости',
  sale_updates_textarea_label: 'Основной текст',
  sale_updates_textarea_placeholder: 'Расскажите детальнее о своих достижениях или новостях проекта',
  sale_updates_add_note_bt: 'Добавить запись',
  sale_updates_add_note_text: 'Опубликованные записи нельзя редактировать или удалять — проверьте всё перед публикацией',
  sale_updates_empty_header: 'Есть новости о проекте?',
  sale_updates_empty_text: 'Поделитесь ими с инвесторами',
  sale_token_created: 'Актив уже создан и подтвержден Администратором. Вы не можете редактировать или изменять его',
  // settings_view
  set_header: 'Настройки',
  set_logout: 'Выйти из аккаунта',
  set_dialog_title: 'Вы действительно хотите выйти из своего аккаунта?',
  set_dialog_content: 'Мы останемся здесь и будем ждать вашего возвращения',
  set_bt_confirm: 'Выйти из аккаунта',
  set_bt_cancel: 'Отменить',
  set_account: 'Учетная запись',
  set_keys: 'Ключи',
  set_withdraw: 'Вывод',
  set_security: 'Безопасность',
  set_verify_account: 'Верификация',
  set_account_id: 'ID учетной записи',
  set_secret_seed: 'Приватный ключ',
  set_copy_secret_seed: 'Скопировать приватный ключ',
  set_your_account_id: 'ID Вашей учетной записи',
  set_change_password: 'Изменить пароль',
  set_change_uplata_insha: 'Карты Visa Iнша',
  set_change_taid: 'Карты UPLATA',
  set_provide_pwd: 'Введите новый пароль',
  set_help_pwd: 'Надежный пароль помогает предотвратить несанкционированный доступ к вашей учетной записи',
  set_pwd_do_not_match: 'Пароли не совпадают',
  set_pwd_changed: 'Пароль изменен',
  set_tfa: '2-х факторная аутентификация',
  set_tfa_enable: 'Включить 2-х факторную аутентификацию',
  set_tfa_copy_code: 'Сканировать код 2-х факторной аутентификации',
  set_tfa_scan_the_qr_code: 'Сканировать QR-код с помощью приложения 2FA',
  set_or_manually_enter: 'Или введите секретный код вручную',
  set_paste_tfa_code: 'Предоставьте ',
  set_seed_description: 'Приватный ключ - это личная информация, подтверждающая, что вы - владелец своей учетной записи',
  set_uplata_insha_added: 'Visa Iнша карта добавлена',
  set_uplata_insha_changed: 'Параметры автовывода Visa Iнша изменены',
  set_uplata_insha_deleted: 'Visa Iнша карта удалена',
  set_confirm_autowithdraw_change: 'Автовывод разрешен лищь для одной карты. \nОтключить автовывод для %{name} id="%{id}"?',
  set_taid_added: 'UPLATA карта добавлена',
  set_taid_changed: 'Параметры автовывода UPLATA изменены',
  set_taid_deleted: 'UPLATA карта удалена',
  set_cards_changed: 'Параметры автовывода изменены',
  set_my_cards: 'Мои карты',
  set_change_xpay: 'Платежные карты',
  // signup_view
  su_email: 'Email',
  su_pwd: 'Пароль',
  su_confirm: 'Подтвердите пароль',
  su_already_have_an_account: 'У вас уже есть аккаунт?',
  su_sign_in: 'Войти сейчас',
  su_sign_up: 'Зарегистрироваться',
  chart_assets: 'Активы',
  su_documents_text: 'Нажимая кнопку ЗАРЕГИСТРИРОВАТЬСЯ, Вы принимаете',
  su_documents_user_agreement: 'Пользовательское соглашение,',
  su_documents_terms_service: 'Условия использования,',
  su_documents_privacy_policy: 'Политику конфиденциальности.',
  // trade_view
  trd_want: 'Хочу',
  trd_order: 'Продаю',
  trd_base: 'Базовый',
  trd_quote: 'Котируемый',
  trd_price: 'Цена',
  trd_created: 'Создано',
  trd_ask: 'Покупка',
  trd_bid: 'Продажа',
  trd_offer_canceled: 'Предложение успешно отменено',
  trd_offer_created: 'Предложение успешно создано',
  trd_offer_failed_to_cancel: 'Не удалось отменить предложение',
  trd_order_not_enough_funds: 'Недостаточно средств!',
  trd_some_went_wrong: 'Что-то пошло не так...',
  trd_no_trade_history: 'Нет истории торгов',
  trd_no_orders_history: 'Нет заявок',
  trd_here_will_be_the_list: 'Список совершенных сделок',
  trd_here_will_be_the_order_list: 'Список текущих заявок',
  trd_here_will_be_the_order_ask_list: 'Здесь будет список текущих запросов',
  trd_here_will_be_the_order_bid_list: 'Здесь будет список текущих бидов',
  trd_validate_minimal_price: 'Цена должна быть больше %{value}',
  trd_validate_minimal_amount: 'Минимальная сумма составляет %{value}',
  trd_price_per: 'Цена за 1 %{asset}',
  trd_amount_for: 'Сумма %{asset}',
  trd_total_value: 'Всего %{value}',
  trd_total_sell: 'Хочу продать %{asset}',
  trd_will_receive: 'Получу %{value}',
  trd_create_sell_order: 'Создать заявку на продажу %{value}',
  trd_create_buy_order: 'Создать заявку на покупку %{value}',
  trd_history: 'История торгов',
  trd_history_amount: 'Сумма (%{asset})',
  trd_history_price: 'Цена (%{asset})',
  trd_history_total: 'Всего (%{asset})',
  trd_history_time: 'Время',
  trd_manage: 'Ваши открытые %{pair} заявки',
  trd_manage_date: 'Дата',
  trd_manage_market: 'Рынок',
  trd_manage_order: 'Заявка',
  trd_order_wdrawal: 'Заявленная сумма',
  trd_manage_base_asset_amount: 'Количество базового актива',
  trd_manage_quote_asset_price: 'Цена в котируемом активе',
  search_campaign: 'Поиск краудфандинговых проектов',
  trd_order_buy: 'Купить',
  trd_order_sell: 'Продать',
  trd_market_price: 'Рыночная цена',
  trd_since_last: 'начиная с прошлого %{value}',
  trd_chart_hour: 'Час',
  trd_chart_day: 'День',
  trd_chart_month: 'Месяц',
  trd_chart_year: 'Год',
  trd_orders: 'Открытые заявки',
  trd_confirm_match: 'Нажав "Подтвердить", вы создаете заявку противоположную выбранной',
  trd_no_pairs: 'Нет торговых пар',
  trd_no_pairs_exp: 'Эта функция будет доступна после появления любой торговой пары',
  trd_no_exchange_pairs: 'Нет зарегестрированных торговых пар, доступных для конвертации валют',
  trd_no_exchange_pairs_exp: 'Эта функция будет доступна после появления торговой пары',
  trd_load_rates_failed: 'Ошибка при чтении курсов для %{source}',
  trd_balance: 'Ваш баланс %{base} / %{quote}',
  // transfers_view
  tr_send: 'Отправить',
  tr_confirm: 'Подтверждение платежа',
  tr_operation_confirm: 'Подтверждение операции',
  tr_recipient_not_found: 'Получатель не найден',
  tr_pay_fee_for_rec: 'Оплатить комиссию вместо получателя',
  tr_successful: 'Платеж совершен успешно',
  tr_no_assets: 'В вашем кошельке нет торговых активов',
  tr_no_assets_exp: 'Эта функция будет доступна, как только у вас появится любой передаваемый актив ',
  tr_no_assets_exists: 'В системе не существует активов',
  tr_no_assets_exists_exp: 'Эту функция будет доступна, как только появится любой актив',
  tr_balance: 'Ваш баланс %{balance} %{token}',
  tr_create_mass: 'Создать массовый перевод',
  tr_mass_about: 'Загрузите .csv файл, в котором содержатся электронная почта или ID пользователя, сумма и актив перевода. Информация для каждого получателя указывается в новой строке.',
  tr_tell_me_more: 'Хочу знать больше',
  tr_about_csv: 'Пример файла csv',
  tr_how_to_create_csv: 'Как создать .CSV файл',
  tr_mass_about_detailed: 'В формате CSV поля данных разделяются запятой. Здесь вы можете скачать пример таблицы:',
  tr_should_look_like: 'должно выглядеть так:',
  tr_use_editor: 'Также вы можете экспортировать .csv из текстовых редакторов (например, Notepad, Microsoft Excel, OpenOffice Calc, или Google Docs)',
  tr_total_amount: 'Общая сумма',
  tr_total_source_fee: 'Общая сумма комиссии отправителя',
  tr_total_recipient_fee: 'Общая сумма комиссии получателя',
  tr_mass_payment_details: 'Ваша оплата составит:',
  tr_mass_payment_failed: 'Одна или несколько операций недействительны. Пожалуйста, просмотрите их и попробуйте снова',
  tr_current_recipient_not_found: 'получатель %{recipient} не найден',
  tr_less_than_fee: 'Отправляемая сумма меньше требуемой платы комиссии',
  tr_greater_than_balance: 'Отправляемая сумма превышает баланс',
  tr_sending_error: 'Ошибка отправки',
  tr_transfer_balance: 'Баланс %{amount} %{asset}.',
  tr_found_errors: 'Ошибки',
  tr_not_valid_file: 'Операция неуспешна, данные загруженного файла неверны',
  tr_digital_values: 'Цифровые номиналы',
  tr_no_digital_values: 'Нет в наличии',
  tr_digital_values_for: 'за',
  tr_conformation_buing_sertificate: 'Вы действительно хотите купить сертификат номиналом %{amountX} %{currencyX} за %{amountY} %{currencyY}?',
  tr_greater_amount_and_commissions: 'Отправляемая сумма с коммиссиями превышает баланс',
  // tx-history_view
  th_transaction_history: 'История транзакций',
  th_failed_to_load_tx: 'Не удалось загрузить историю',
  th_no_transaction_history: 'Вы пока не сделали ни одной транзакции',
  th_here_will_be_the_list: 'Здесь будет отображен список ваших транзакций',
  th_no_transaction_history_search: 'Попробуйте поискать по другим активам или ',
  th_no_transaction_history_search_end: ', если у Вас есть вопросы',
  th_no_assets_in_your_wallet: 'В вашем кошельке нет активов',
  th_no_balances_in_your_wallet: 'В вашем кошельке нет доступной валюты для обмена',
  th_no_currencies_in_your_wallet: 'В вашем кошельке нет конвертируемых активов',
  th_here_will_be_tokens: 'Здесь будет отображаться список ваших активов',
  th_sub: 'Добавить',
  th_export_btn: 'Экспорт',
  th_export_popup_title: 'Экспорт транзакций',
  th_export_popup_text: 'Выберите нужные фильтры',
  // verification_view
  kyc_i_agree: 'Я подтверждаю, что ознакомился с <a @click.stop.prevent>Пользовательским соглашением</a> и <a @click.stop.prevent>Политикой конфиденциальности</a>, а также то, что мне уже исполнилось 18 лет.',
  kyc_account_verification: 'Верификация учетной записи',
  kyc_data_processed: 'Ваши данные проходят обработку',
  kyc_address_details: 'Подробности адреса',
  kyc_required_documents: 'Необходимые документы',
  kyc_document_not_attached: 'документ не прикреплен',
  kyc_photo_verification: 'Фото верификация',
  kyc_photo_explain: 'Для того, чтобы мы знали, что это именно вы предоставляете документы, пожалуйста, сделайте фото с уникальным сгенерированным кодом',
  kyc_show_key: 'Показать ключ',
  kyc_verification_key: 'Ключ подтверждения',
  kyc_not_all_docs: 'Пожалуйста, загрузите все документы перед отправкой',
  kyc_upload_success: 'Информация загружена. Пожалуйста, дождитесь подтверждения',
  kyc_current_account_state: 'Текущий статус учетной записи',
  kyc_approved_msg: 'Ваш аккаунт одобрен. Все действия, требующие верификации, теперь доступны',
  kyc_approved_syndicate: 'Ваш аккаунт одобрен, вы корпоративный пользователь. Все действия, требующие верификации, теперь доступны',
  kyc_waiting_msg: 'Ваш запрос на верификацию отправлен. Пожалуйста, подождите, пока информация будет рассмотрена.\nВы сможете обновить детали после рассмотрения запроса',
  kyc_rejected_msg: 'К сожалению, ваша учетная запись была отклонена по причине: %{reason}',
  kyc_personal_details: 'Персональные подробности',
  kyc_corporate_details: 'Корпоративные подробности',
  kyc_documents: 'Документы',
  kyc_approved_title: 'Учетная запись подтверждена. <br>Вы зарегистрированы как %{account_type} пользователь.',
  kyc_update: 'ОБНОВИТЬ ДАННЫЕ KYC',
  kyc_general: 'Общий',
  kyc_submit: 'Пройти верификацию',
  kyc_pass: 'Пройти верификацию',
  kyc_check_status: 'Проверить статус верификации',
  kyc_corporate: 'Корпоративный',
  kyc_inv_tip: 'Может инвестировать в проекты',
  kyc_corporate_tip: 'Может создавать проекты',
  kyc_rejected_title: 'Ваш запрос на верификацию отклонен',
  kyc_rejected_msg_html: 'К сожалению, ваша учетная запись была отклонена по причине: <span class="reject-message">%{reason}</span>',
  kyc_not_privacy_policy: 'Пожалуйста, примите Политику конфиденциальности перед отправкой',
  kyc_form_submit: 'Отправка формы для прохождения KYC процедуры',
  kyc_general_company_information: 'Общая информация о компании',
  kyc_company_legal_address: 'Юридический адрес компании',
  kyc_business_model: 'Бизнес-модель',
  kyc_company_documents: 'Документы компании',
  kyc_company_directors: 'Директора и акционеры',
  kyc_residence_address: 'Детали адреса проживания',
  kyc_address_proof: 'Документ, подтверждающий адрес',
  kyc_submit_company_documents: 'Отправить документы компании',
  kyc_upload_memorandium: 'Загрузите сканкопию Меморандума и Статута',
  kyc_upload_signatories: 'Загрузите сканкопию авторизации подписантов компании',
  kyc_upload_chart: 'Загрузите файл с организационной структурой компании',
  kyc_upload_address: 'Загрузите сканкопию документа, подтвержающего адрес',
  kyc_upload_id: 'Загрузите сканкопию документа, удостоверяющего личность',
  kyc_upload_certificate_of_shareholders: 'Загрузите сканкопию Сертификата акционеров и директоров',
  kyc_upload_annual_report: 'Загрузите сканкопию последнего годового отчета компании',
  kyc_upload_origination_certificate: 'Загрузите сканкопию Свидетельства о регистрации',
  kyc_company_industry: 'Отрасль компании',
  kyc_company_website: 'Вебсайт компании',
  kyc_company_phone: 'Номер телефона компании',
  kyc_corp_step1_subhead: 'Все документы, кроме описания бизнес-модели, организационной структуры и вебсайта компании, должны быть нотариалально заверены должностным лицом, назначенным местным правительством. Это лицо выступает в качестве беспристрастного свидетеля различных официальных мер противодействия мошенничеству, связанных с подписанием важных документов',
  kyc_submit_legal_address: 'Пожалуйста, подтвердите следующую информацию о юридическом адресе',
  kyc_upload_audited_copy: 'Загрузите заверенную копию, если это возможно. Если это невозможно, загрузите самую последнюю выписку из банковского счета компании. Банковская выписка потребуется для всех компаний, которые ведут торговую деятельность менее 12 месяцев. Для более крупных компаний требуются налоговые декларации за предыдущие 3 года',
  kyc_submit_full_kyc_docs: 'Предоставьте полный перечень документов, необходимых для похождения процедуры KYC для всех директоров и акционеров компании (если они отличаются и имеют долю более 10%)',
  kyc_submit_docs: 'Предоставьте документацию компании(й)',
  kyc_submit_residence_address: 'Пожалуйста, предоставьте следующую информацию о месте жительства',
  kyc_upload_address_proof: 'Пожалуйста, загрузите документ, подтверждающий адрес',
  kyc_upload_business_model: 'Загрузите файл с описанием бизнес-модели',
  kyc_submit_personal_information: 'Пожалуйста, предоставьте следующую личную информацию',
  kyc_upload_one_of_docs: 'Пожалуйста, загрузите один из документов:',
  kyc_upload_document_photo: 'Загрузите фото документа',
  kyc_id_docs_tip: 'Рукописные документы или документы на иностранном языке, которые не могут быть прочитаны, т.е. арабский или кириллица, не будут приняты, если они не переведены и не заверены нотариально',
  kyc_driver_license: 'Водительские права, если они еще не загружены на предыдущем этапе',
  kyc_utility_bill: 'Актуальный счет за коммунальные услуги (не позднее 6 месяцев)',
  kyc_bank_statement: 'Банковская выписка или выписка по кредитной карте (не позднее 6 месяцев)',
  kyc_bank_reference_letter: 'Банковское рекомендательное письмо (не позднее 6 месяцев)',
  kyc_signed_tenancy: 'Подписанный договор аренды',
  kyc_valid_passport: 'Действительный паспорт',
  kyc_driving_license: 'Водительское удостоверение - полное, не временное, с цветной фотографией',
  kyc_national_id: 'Действительный национальный документ удостоверерения личности',
  kyc_copy_passport: 'Нотариально заверенная копия действительного паспорта с изображением',
  kyc_copy_driver_license: 'Нотариально заверенная копия водительских прав с изображением',
  kyc_copy_national_id: 'Нотариально заверенная копия действующего национального удостоверения личности с изображением',
  kyc_corporate_copy_current_tax: 'Нотариально заверенная копия налоговой декларации за последние 12 месяцев',
  kyc_corporate_copy_bank_statement: 'Нотариально заверенная копия выписки из банка или выписки по кредитной карте (не старше 3 месяцев)',
  kyc_corporate_copy_utility_bill: 'Нотариально заверенная копия счета за коммунальные услуги (не позже 3 месяцев)',
  kyc_submit_document: 'Пожалуйста, предоставьте следующие документы',
  kyc_document_details: 'Детали документа',
  // verification_new
  verif_investor: 'Инвестор',
  verif_issuer: 'Эмитент',
  verif_description_step1_issuer: 'Подойдёт вам, если вы хотите создавать собственные проекты, которые нуждаются в инвестировании',
  verif_description_step1_investor: 'Подойдёт вам, если вы хотите инвестировать и получать доход',
  verif_description_step2: 'DIT не хранит ваши персональные данные — они хранятся на серверах нашего партнёра Sumsub, которые надёжно защищены',
  verif_step3_title: 'Мы верифицировали ваши данные, вам осталось только подтвердить тип аккаунта',
  verif_your_acc: 'Ваш тип аккаунта — ',
  verif_step3_descritption: 'После подтверждения вы не сможете поменять тип аккаунта. Если передумали — выберите другой тип и пройдите верификацию заново.',
  verif_change_acc: 'Сменить тип аккаунта',
  verif_success_investor_title: 'Отлично, мы подтвердили ваш аккаунт инвестора',
  verif_success_issuer_title: 'Отлично, мы подтвердили ваш аккаунт эмитента',
  verif_success_investor_subtitle: 'Теперь вы можете пополнять счёт, инвестировать в проекты и получать дивиденды',
  verif_success_issuer_subtitle: 'Теперь вы можете создавать проекты, получать инвестиции и выплачивать дивиденды инвесторам',
  verif_success_investor_text: 'Давайте поищем интересные проекты для инвестиции — наверняка вы найдете что-то по душе',
  verif_success_issuer_text: 'Уже есть идея для проекта? Так чего же мы ждём, давайте создадим ваш первый проект!',
  // withdrawal_view
  withdraw_percent_fee: 'процентная комиссия',
  withdraw_fixed_fee: 'фиксированная комиссия',
  withdraw_approve: 'Принять',
  withdraw_reject: 'Отказать',
  withdraw_withdraw: 'Вывести',
  withdraw_withdraw_option: 'Выберите способ вывода',
  withdraw_withdrawal: 'Вывод средств',
  withdraw_details: 'Запрос на вывод',
  withdraw_pending: 'Создан',
  withdraw_created: 'Создан',
  withdraw_approved: 'Принят',
  withdraw_cancelled: 'Отменен',
  withdraw_rejected: 'Отклонен',
  withdraw_permanently_rejected: 'Отклонен',
  withdraw_confirm: 'Подтверждение вывода',
  withdraw_how_much: 'Минимальная сумма вывода: %{value} %{asset}. ',
  withdraw_network_fee: 'При выводе средств может взиматься комиссия банка.',
  withdraw_insha_fee: 'Минимальная сумма вывода: 11.00 UAH. Комиссия банка: 10.00 UAH',
  withdraw_eth_btc: 'Минимальная сумма вывода: %{value} %{asset}.',
  withdraw_ex_address: 'Вывод на внешний адрес',
  withdraw_to: 'Вывод на:',
  withdraw_cashbox: 'Вывод через кассу',
  withdraw_ucash: 'UPLATA (ID %{taid})',
  withdraw_uplata_insha: 'Visa Iнша (%{uplataInsha})',
  withdraw_xpay: '%{name} (%{mask_pan})',
  withdraw_external: 'Адрес %{asset}',
  withdraw_nothere: 'Вывод не возможен',
  withdraw_success: 'Запрос на вывод успешно создан',
  withdraw_error_is_trying_to_send_to_yourself: 'Отправитель не может быть получателем! Проверьте корректность адреса',
  withdraw_error_invalid_address: 'Недействительный адрес кошелька',
  withdraw_error_insufficient_funds: 'Недостаточно средств',
  withdraw_error_minimum_amount: 'Минимальная сумма составляет %{value} %{asset}',
  withdraw_error_maximum_amount: 'Максимальная сумма составляет %{value} %{asset}',
  withdraw_no_withdrawals: 'Нет запросов',
  withdraw_no_withdrawals_desc: 'Здесь будет отображаться список запросов на вывод средств',
  withdraw_no_assets: 'В вашем кошельке нет активов, которые могут быть выведены',
  withdraw_no_assets_exp: 'Эта функция будет доступна, как только у вас будет актив, который можно вывести',
  withdraw_amount_round: 'Сумма вывода будет округлена до %{amount} %{asset}',
  withdraw_reject_reason_prompt: 'Введите причину отказа',
  withdraw_reject_reason_warn: 'Поле не должно быть пустым',
  withdraw_request_approved: 'Запрос на вывод одобрен',
  withdraw_request_rejected: 'Запрос на вывод отклонен',
  withdraw_creation_date: 'Дата создания',
  withdraw_updating_date: 'Дата обновления',
  withdraw_list_tooltip: 'Используйте двойной щелчек мыши для открытия формы подтверждения',
  withdraw_usdt_delay_msg: 'После создания транзакции, позаботьтесь, пожалуйста, о ее статусе на экране списка транзакций, возможно применение задержки',
  withdraw_usdt_tx_sent: 'Транзакция отправлена',
  withdraw_usdt_tx_sent_automaticly: 'Транзакция была отправлена автоматически',
  withdraw_usdt_tx_cancelled: 'Транзакция отменена. Ваши средства скоро вернутся на ваш кошелек',
  withdraw_usdt_tx_cancelled_automaticly: 'Вы не успели отменить транзакцию. Транзакция была отправлена автоматически',
  validate_amount_number: 'Сумма должна быть положительным числом',
  valid_email_or_id: 'Тут должен быть корректный email или id пользователя',
  valid_secret_key: 'Тут должен быть корректный секретный ключ',
  valid_account_id: 'Тут должен быть корректный id пользовательского аккаунта',
  valid_password_az: 'Пароль должен содержать символы a-z, A-Z и 0-9',
  invalid_phone_number: 'Неправильный номер телефона',
  invalid_wallet_address: 'Неправильный адрес кошелька',
  // notifications
  notification_transaction_income: 'Вы получили новый платеж на сумму %{amount} %{asset} от %{sender_name} (%{sender_email})',
  notification_transaction_emission: 'Новый выпуск эмисии %{amount} %{asset}',
  notification_transaction_exchange: 'Вы успешно обменяли %{source_amount} %{source_asset} за %{amount} %{asset}',
  notification_contract_money_lock: 'Ваши средства в размере %{amount} %{asset} были зарезервированы за инвойсом %{invoice_number} контракта %{contract_number}.',
  notification_no_new_notifications: 'Нет новых уведомлений!',
  notification_kyc_to_not_verified: 'Вас переведено в статус неверифицированного пользователя',
  notification_kyc_approve: 'Ваша учетная запись успешно верифицирована',
  notification_kyc_reject: 'К сожалению, мы не смогли верифицировать Ваш аккаунт. Пожалуйста, подайте заявку еще раз, строго следуя нашим рекомендациям.',
  notif_success_copied: 'Ваш email скопирован успешно',
  notif_one_time_wallet_copied: 'Адрес одноразового кошелька скопирован успешно',

  contact_title: 'Напишите нам',
  contact_text: 'Команда CryptoPort ответит на все Ваши вопросы',
  contact_send: 'Отправить',
  contact_name: 'Имя',
  contact_email: 'E-mail',
  contact_theme: 'Тема письма',
  contact_message: 'Сообщение',
  contact_send_error: 'Похоже, что-то пошло не так. Ваше сообщение не удалось отправить. Пожалуйста, попробуйте еще раз позже.',
  contact_email_invalid: 'Неверный формат email',
  contact_empty_field: 'Поле обязательно для заполнения',
  contact_success: 'Ваше сообщение успешно отправлено',
  webshop_ticket_not_found: 'Ордер не найден!',
  // topup_view
  topup_refill: 'Пополнение баланса',
  topup_topup: 'Пополнить',
  topup_balance: 'Ваш баланс составляет %{amount} %{asset}',
  topup_percent_fee: 'процентная комиссия',
  topup_fixed_fee: 'фиксированная комиссия',
  topup_approve: '6-Принять',
  topup_reject: '7-Отказать',
  topup_withdraw: 'Выберите способ пополнения',
  topup_withdrawal: 'Ввод',
  topup_details: '10-Запрос на ввод',
  topup_pending: 'Создан',
  topup_created: 'Создан',
  topup_approved: 'Принят',
  topup_cancelled: 'Отменен',
  topup_rejected: 'Отклонен',
  topup_permanently_rejected: 'Отклонен',
  topup_confirm: 'Подтверждение ввода',
  topup_how_much: 'Минимальная сумма пополнения: %{value} %{asset}',
  topup_minimal: 'При пополнении баланса может взиматься комиссия банка',
  topup_crypto_minimal: 'Учитывайте, что при пополнении баланса с Вас может взиматься комиссия сети.',
  topup_failed_get_address: 'Не удалось получить адрес.',
  topup_network_fee: 'Также учтите, что в дополнение к сумме ввода будет снята комиссия',
  topup_ex_address: 'Ввод c внешнего адреса',
  topup_to: 'Ввод с:',
  topup_cashbox: 'Ввод через кассу',
  topup_ucash: 'UPLATA (ID %{taid})',
  topup_uplata_insha: 'Visa Iнша (%{uplataInsha})',
  topup_xpay: '%{name} (%{mask_pan})',
  topup_external: 'Адрес %{asset}',
  topup_add_xpay_card: 'Добавьте платежную карту',
  topup_nothere: 'Ввод не возможен',
  topup_success: 'Запрос на ввод успешно создан',
  topup_request: 'Запрос на ввод',
  topup_error_is_trying_to_send_to_yourself: 'Отправитель не может быть получателем! Проверьте корректность адреса',
  topup_error_invalid_address: 'Недействительный адрес кошелька',
  topup_error_insufficient_funds: 'Недостаточно средств',
  topup_error_minimum_amount: 'Минимальная сумма составляет %{value} %{asset}',
  topup_error_maximum_amount: 'Максимальная сумма составляет %{value} %{asset}',
  topup_no_withdrawals: 'Нет запросов',
  topup_no_withdrawals_desc: 'Здесь будет отображаться список запросов на ввод средств',
  topup_no_assets: 'В вашем кошельке нет активов, которые могут быть выведены',
  topup_no_assets_exp: 'Эта функция будет доступна, как только у вас будет актив, который можно вывести',
  topup_amount_round: 'Сумма будет округлена до %{amount} %{asset}',
  topup_reject_reason_prompt: 'Введите причину отказа',
  topup_reject_reason_warn: 'Поле не должно быть пустым',
  topup_request_approved: 'Запрос на ввод одобрен',
  topup_request_rejected: 'Запрос на ввод отклонен',
  topup_creation_date: 'Дата создания',
  topup_updating_date: 'Дата обновления',
  topup_list_tooltip: 'Используйте двойной щелчек мыши для открытия формы подтверждения',
  topup_otp_code_confirm: 'Подтверждение OTP кода',
  topup_secure_msg_status_1: 'Принят для обработки',
  topup_secure_msg_status_2: 'Проверка карты на 3DS',
  topup_secure_msg_status_3: 'Ожидание подтверждения OTP',
  topup_secure_msg_status_4: 'Операция в очереди',
  topup_secure_msg_status_5: 'Операция в обработке',
  topup_secure_msg_status_6: 'Счет создан, ожидает оплаты',
  topup_secure_msg_status_7: 'По операции проведен расчет комиссии',
  topup_secure_msg_status_10: 'Операция проведена',
  topup_secure_msg_status_20: 'Ошибка верификации 3DS',
  topup_secure_msg_status_21: 'Ошибка проведения операции',
  // navbar
  nav_search: 'Найти проект...',
  nav_not_verifying_user_msg: 'Функционал вашего аккаунта ограничен',
  nav_go_through_verification: 'пройдите верификацию',
  // dividends
  divid_fund_name: 'Название проекта',
  divid_tokens_issued: 'Количество выпущенных активов',
  divid_total_investments: 'Общая сумма инвестиций',
  divid_total_payments: 'Общая сумма выплат по дивидендам',
  divid_payments_description: 'Введите сумму выплат дивидендов, которая распределится между инвесторами',
  divid_investors_list: 'Список инвесторов',
  divid_to_pay: 'Дивиденды к выплате',
  divid_footer_description: 'Срок вашего проекта заканчивается через 15 дней — после этого вы будете обязаны выплатить все дивиденды инвесторам',
  divid_total_pay: 'Общая сумма выплат дивидендов',
  divid_your_balance: 'Ваш баланс',
  divid_pay_btn: 'Выплатить дивиденды инвесторам',
  divid_accept_pay: 'Вы подтверждаете выплату дивидендов инвесторам?',
  divid_will_debited: 'Мы спишем с вашего счёта <span style="color: #42A1F8">%{amount} %{currency}</span> и выполним массовый перевод инвесторам',
  divid_can_search: 'Вы сможете отследить платёж кадому инвестору позже в разделе «История транзакций»',
  divid_success_title: 'Отлично, инвесторы получили свои дивиденды',
  divid_success_sub_title: 'Поздравляем вас с успешным завершением проекта. Мы рады, что CryptoPort помог вашему делу — для нас это тоже победа.',
  divid_success_text: 'Подтвердить транзакции инвесторам вы можете в разделе «История транзакций»',
  divid_term_month: 'мес.',
  divid_tab_finish_title: 'Проект завершен — загрузите финансовый отчёт и выплатите дивиденды инвесторам',
  divid_tab_finish_text: ', чтобы загрузить финансовый отчёт',
  divid_ready_to_pay: 'Готовы выплатить дивиденды инвесторам?',
  divid_ready_to_pay_text: 'Срок вашего проекта заканчивается через 15 дней — после этого вы будете обязаны выплатить все дивиденды инвесторам. Или можете сделать это раньше, например сейчас.',
  divid_save_report: 'Загрузите сюда финансовый отчёт, чтобы добавить его к проекту',
  divid_pay_error: 'Не удалось выплатить дивиденды. Проверьте внесенные данные или попробуйте позже',
  divid_pay_subject: 'Dividends from %{name} project',
  // errors
  token_already_exists: 'Актив уже существует в системе. Попробуйте изменить код актива',
  // new
  swap_exchange: 'Swap обмен',
  operation_type: 'Тип операции',
  verification_needed_msg: 'Пройдите верификацию чтобы использовать кошелёк и другие функции.',
  amount_step_title: 'Введите сумму',
  wallet_step_title: 'Адрес кошелька',
  crypto_chart_title: 'Криптовалюты'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/ru/ru_all.js